"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sdk_js_1 = require("@pataflags/sdk-js");
const tiny_emitter_1 = require("tiny-emitter");
const Storage_1 = require("./Storage");
class Store {
    constructor(storage) {
        this.storage = storage;
        this.emitter = new tiny_emitter_1.TinyEmitter();
        this.shadowEvaluation = null;
    }
    static create(storage) {
        if (storage instanceof Object)
            return storage;
        if (storage === 'session')
            return new Store(new Storage_1.SessionStorage());
        if (storage === 'persistent')
            return new Store(new Storage_1.PersistentStorage());
        return new Store(new Storage_1.InMemoryStorage());
    }
    onReady(callback) {
        this.emitter.on('ready', callback);
    }
    onChanges(callback) {
        this.emitter.on('changes', callback);
    }
    isInitialized() {
        return !!this.shadowEvaluation;
    }
    tryInitialize() {
        this.initialize(this.storage.get());
    }
    forceInitialize(fallback) {
        this.initialize(this.storage.get() || fallback);
    }
    persist(evaluation) {
        if (!this.isInitialized()) {
            if (this.storage.persist(evaluation)) {
                this.shadowEvaluation = evaluation;
                this.emitter.emit('ready');
            }
        }
        else {
            if (this.storage.persist(evaluation)) {
                this.shadowEvaluation = evaluation;
                this.emitter.emit('changes');
            }
        }
    }
    ensureEvaluation() {
        return this.shadowEvaluation || sdk_js_1.PFDefaultEvaluation;
    }
    initialize(initialEvaluation) {
        if (!this.isInitialized()) {
            this.shadowEvaluation = initialEvaluation;
            if (this.isInitialized()) {
                this.emitter.emit('ready');
            }
        }
    }
}
exports.Store = Store;
//# sourceMappingURL=Store.js.map